import { Notification } from 'baseui/notification';
import { AlertSVG } from 'common/assets';
import { SeparatorHorizontal, SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';

interface Props {
  text: string;
}

export default function CustomerSnackBar(props: Props) {
  return (
    <>
      <Notification
        closeable={false}
        kind="warning"
        overrides={{
          Body: {
            style: {
              margin: '0',
              alignItems: 'center',
              width: '100%',
            },
          },
        }}
      >
        {() => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <AlertSVG size={16} />
            <SeparatorHorizontal $margin={16} />
            <span>{props.text}</span>
          </div>
        )}
      </Notification>
      <SeparatorVertical $margin={8} />
    </>
  );
}
